import { render, staticRenderFns } from "./DeleteBtn.vue?vue&type=template&id=37322dfc&scoped=true&"
import script from "./DeleteBtn.vue?vue&type=script&lang=js&"
export * from "./DeleteBtn.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBtn.vue?vue&type=style&index=0&id=37322dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37322dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37322dfc')) {
      api.createRecord('37322dfc', component.options)
    } else {
      api.reload('37322dfc', component.options)
    }
    module.hot.accept("./DeleteBtn.vue?vue&type=template&id=37322dfc&scoped=true&", function () {
      api.rerender('37322dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/EditAttachments/DeleteBtn.vue"
export default component.exports